import { ref, nextTick } from '@vue/composition-api'

export default function useFormAlert() {
  const message = ref(null)
  const type = ref('warning')
  let timer = null

  function apply(msg, autoDismiss) {
    message.value = msg
    if (autoDismiss) {
      timer = setTimeout(() => { message.value = null }, 5000)
    }
  }

  function show(msg, alertType, autoDismiss) {
    clearTimeout(timer)
    type.value = alertType
    if (message.value != null) {
      message.value = null
      nextTick(() => apply(msg, autoDismiss))
    } else {
      apply(msg, autoDismiss)
    }
  }

  function showError(msg) { show(msg, 'warning', true) }
  function showSuccess(msg) { show(msg != null ? msg : 'Success', 'success', true) }
  function showPersistentError(msg) { show(msg, 'warning', false) }
  function clear() {
    clearTimeout(timer)
    message.value = null
  }

  return { message, type, showError, showSuccess, showPersistentError, clear }
}



// WEBPACK FOOTER //
// ./src/composables/useFormAlert.js